import React, { CSSProperties } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import './index.less';

interface IProps {
  title: string;
  description: string;
  style?: CSSProperties;
  linkTo?: string;
}

const CTASection = ({ style, title, description, linkTo = `/existing-brands/signup` }: IProps) => {
  return (
    <div className="cta-section" style={style}>
      <div className="cta-section-container">
        <h3>{title}</h3>
        <div className="footer">
          <Link href={linkTo}>
            <button>
              <Image width={12} height={12} src="/images/phone.svg" alt="phone" />
              <p>Get in touch</p>
            </button>
          </Link>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
